import '../styles/NotFound.css'
import searchNotFound from '../images/search-not-found.svg'

export default function SearchNotFound() {
  return (
    <div className="GoalNotFound">
      <img src={searchNotFound} alt='No Result Found'/>
    </div>
  )
}